import { render, staticRenderFns } from "./ControlPointListAdmin.vue?vue&type=template&id=1d9bf742&"
import script from "./ControlPointListAdmin.vue?vue&type=script&lang=js&"
export * from "./ControlPointListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports